module.exports = __webpack_public_path__ + "img/single-storey-houses-2.a74cd5ce.jpg";